import { render, staticRenderFns } from "./GridDimensions.vue?vue&type=template&id=616975ed&scoped=true"
import script from "./GridDimensions.vue?vue&type=script&lang=js"
export * from "./GridDimensions.vue?vue&type=script&lang=js"
import style0 from "./GridDimensions.vue?vue&type=style&index=0&id=616975ed&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616975ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616975ed')) {
      api.createRecord('616975ed', component.options)
    } else {
      api.reload('616975ed', component.options)
    }
    module.hot.accept("./GridDimensions.vue?vue&type=template&id=616975ed&scoped=true", function () {
      api.rerender('616975ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/PublicDisplayOptions/GridDimensions.vue"
export default component.exports